import { render } from "./PaymentTermList.vue?vue&type=template&id=1a121516"
import script from "./PaymentTermList.vue?vue&type=script&lang=js"
export * from "./PaymentTermList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__